import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, Define, ValidationMessage, TibboDataType, SettingOption, CodeBlock,
} from '@appblocks/codegeneration/types';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import General from '@appblocks/codegeneration/Features/General/General';
import PlatformUtils, { TIBBO_DEVICE_ID, DeviceDefinitions } from '@appblocks/platforms/PlatformUtils';

export default class ZephyrGeneral extends BaseFeature {
    constructor() {
        super();
        this.name = 'General';
        this.id = 'general';

        this.files = [
            '/.vscode/launch.json',
            // '/.vscode/extensions.json',
            '/.vscode/tasks.json',
            '/.vscode/settings.json',
            // 'diagram.json',
            // 'wokwi.toml',
            'jlink_flash.jlink',
            'openocd.cfg',
            'README.md',
            'src/utils.cpp',
            'src/utils.h',
        ];

        const settings = [
            {
                id: 'DEVICE_NAME',
                name: 'Device Name',
                settingType: SettingType.STRING,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'GNAME',
                    NAME: 'Device Name',
                    SETTINGTYPE: 'string',
                    DATATYPE: 'S',
                    MAX: 32,
                    DEFAULT: 'Device_Name_1',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
                required: true,
                default: 'Device_Name_1',
                helpText: 'Give your device a name or link it to a setting.',
            },
            {
                id: 'FIRMWAREVERSION',
                name: 'Application Version',
                settingType: SettingType.STRING,
                required: true,
                default: '1.0.0',
                helpText: 'Your application\'s version number, which is shown in the Device Explorer.',
            },
            {
                id: 'TIMEZONE',
                name: 'Time Zone',
                settingType: SettingType.OPTION,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'TZONE',
                    NAME: 'Device Time Zone',
                    SETTINGTYPE: 'string',
                    MIN: 0,
                    MAX: 3,
                    DATATYPE: 'S',
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'STATIC',
                    OPTIONS: [
                        {
                            name: 'UTC-12:00',
                            value: '0',
                        },
                        {
                            name: 'UTC-11:00',
                            value: '1',
                        },
                        {
                            name: 'UTC-10:00',
                            value: '2',
                        },
                        {
                            name: 'UTC-09:00',
                            value: '3',
                        },
                        {
                            name: 'UTC-08:00',
                            value: '4',
                        },
                        {
                            name: 'UTC-07:00',
                            value: '5',
                        },
                        {
                            name: 'UTC-06:00',
                            value: '6',
                        },
                        {
                            name: 'UTC-05:00',
                            value: '7',
                        },
                        {
                            name: 'UTC-04:30',
                            value: '8',
                        },
                        {
                            name: 'UTC-04:00',
                            value: '9',
                        },
                        {
                            name: 'UTC-03:30',
                            value: '10',
                        },
                        {
                            name: 'UTC-03:00',
                            value: '11',
                        },
                        {
                            name: 'UTC-02:00',
                            value: '12',
                        },
                        {
                            name: 'UTC-01:00',
                            value: '13',
                        },
                        {
                            name: 'UTC',
                            value: '14',
                        },
                        {
                            name: 'UTC+01:00',
                            value: '15',
                        },
                        {
                            name: 'UTC+02:00',
                            value: '16',
                        },
                        {
                            name: 'UTC+03:00',
                            value: '17',
                        },
                        {
                            name: 'UTC+03:30',
                            value: '18',
                        },
                        {
                            name: 'UTC+04:00',
                            value: '19',
                        },
                        {
                            name: 'UTC+04:30',
                            value: '20',
                        },
                        {
                            name: 'UTC+05:00',
                            value: '21',
                        },
                        {
                            name: 'UTC+05:30',
                            value: '22',
                        },
                        {
                            name: 'UTC+05:45',
                            value: '23',
                        },
                        {
                            name: 'UTC+06:00',
                            value: '24',
                        },
                        {
                            name: 'UTC+06:30',
                            value: '25',
                        },
                        {
                            name: 'UTC+07:00',
                            value: '26',
                        },
                        {
                            name: 'UTC+08:00',
                            value: '27',
                        },
                        {
                            name: 'UTC+09:00',
                            value: '28',
                        },
                        {
                            name: 'UTC+9:30',
                            value: '29',
                        },
                        {
                            name: 'UTC+10:00',
                            value: '30',
                        },
                        {
                            name: 'UTC+11:00',
                            value: '31',
                        },
                        {
                            name: 'UTC+12:00',
                            value: '32',
                        },
                        {
                            name: 'UTC+13:00',
                            value: '33',
                        },
                    ],
                },
                required: true,
                default: '0',
                options: [
                    {
                        name: 'UTC-12:00',
                        value: '0',
                    },
                    {
                        name: 'UTC-11:00',
                        value: '1',
                    },
                    {
                        name: 'UTC-10:00',
                        value: '2',
                    },
                    {
                        name: 'UTC-09:00',
                        value: '3',
                    },
                    {
                        name: 'UTC-08:00',
                        value: '4',
                    },
                    {
                        name: 'UTC-07:00',
                        value: '5',
                    },
                    {
                        name: 'UTC-06:00',
                        value: '6',
                    },
                    {
                        name: 'UTC-05:00',
                        value: '7',
                    },
                    {
                        name: 'UTC-04:30',
                        value: '8',
                    },
                    {
                        name: 'UTC-04:00',
                        value: '9',
                    },
                    {
                        name: 'UTC-03:30',
                        value: '10',
                    },
                    {
                        name: 'UTC-03:00',
                        value: '11',
                    },
                    {
                        name: 'UTC-02:00',
                        value: '12',
                    },
                    {
                        name: 'UTC-01:00',
                        value: '13',
                    },
                    {
                        name: 'UTC',
                        value: '14',
                    },
                    {
                        name: 'UTC+01:00',
                        value: '15',
                    },
                    {
                        name: 'UTC+02:00',
                        value: '16',
                    },
                    {
                        name: 'UTC+03:00',
                        value: '17',
                    },
                    {
                        name: 'UTC+03:30',
                        value: '18',
                    },
                    {
                        name: 'UTC+04:00',
                        value: '19',
                    },
                    {
                        name: 'UTC+04:30',
                        value: '20',
                    },
                    {
                        name: 'UTC+05:00',
                        value: '21',
                    },
                    {
                        name: 'UTC+05:30',
                        value: '22',
                    },
                    {
                        name: 'UTC+05:45',
                        value: '23',
                    },
                    {
                        name: 'UTC+06:00',
                        value: '24',
                    },
                    {
                        name: 'UTC+06:30',
                        value: '25',
                    },
                    {
                        name: 'UTC+07:00',
                        value: '26',
                    },
                    {
                        name: 'UTC+08:00',
                        value: '27',
                    },
                    {
                        name: 'UTC+09:00',
                        value: '28',
                    },
                    {
                        name: 'UTC+9:30',
                        value: '29',
                    },
                    {
                        name: 'UTC+10:00',
                        value: '30',
                    },
                    {
                        name: 'UTC+11:00',
                        value: '31',
                    },
                    {
                        name: 'UTC+12:00',
                        value: '32',
                    },
                    {
                        name: 'UTC+13:00',
                        value: '33',
                    },
                ],
            },
            {
                id: 'LATITUDE',
                name: 'Latitude',
                settingType: SettingType.NUMBER,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'LAT',
                    NAME: 'Latitude',
                    SETTINGTYPE: 'float',
                    DATATYPE: 'B',
                    MIN: -90,
                    MAX: 90,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
                required: true,
                min: -90,
                max: 90,
                default: '0',
            },
            {
                id: 'LONGITUDE',
                name: 'Longitude',
                settingType: SettingType.NUMBER,
                dataType: TibboDataType.SETTING,
                setting: {
                    SETTINGID: 'LNG',
                    NAME: 'Longitude',
                    SETTINGTYPE: 'float',
                    DATATYPE: 'B',
                    MIN: -180,
                    MAX: 180,
                    DEFAULT: '0',
                },
                UIControl: {
                    CONTROL: 'EDIT',
                },
                required: true,
                min: -180,
                max: 180,
                default: '0',
            },
            {
                id: 'LOGGING',
                name: 'Debug Print Output',
                settingType: SettingType.OPTION,
                required: false,
                default: '',
                refId: 'serial',
                options: [],
                helpText: 'Determines where log data are displayed.',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const projectName = this.project.name;
        const deviceDefinition = DeviceDefinitions[this.project.device.id];
        let jlinkName = '';
        let jlinkSpeed = '4000';
        if (deviceDefinition.uploadMethods.length > 0) {
            const jlinkMethod = deviceDefinition.uploadMethods.find((method: any) => method.name === 'jlink');
            try {
                for (let i = 0; i < jlinkMethod.options.length; i++) {
                    let option = jlinkMethod.options[i];
                    if (option.indexOf('"') === 0) {
                        option = option.substring(1, option.length - 1);
                    }
                    if (option.indexOf('--device=') === 0) {
                        jlinkName = option.split('=')[1];
                    }
                    if (option.indexOf('--speed=') === 0) {
                        jlinkSpeed = option.split('=')[1];
                    }
                }
            } catch (e) {
                //
            }
        }
        // disable all not enabled peripherals
        const peripherals = deviceDefinition.peripherals;
        let boardResetCode = '';
        for (let i = 0; i < peripherals.length; i++) {
            const peripheral = peripherals[i];
            if (peripheral.settings.ENABLED !== undefined && peripheral.settings.ENABLED.value !== '0') {
                boardResetCode += `
&${peripheral.id} {
    status = "disabled";
};`;
            }
        }
        blocks.push({
            location: 'APP_OVERLAY_RESETS',
            blockType: BlockType.CODE,
            template: boardResetCode,
        });

        blocks.push({
            location: 'ZEPHYR_PROJECT_NAME',
            blockType: BlockType.CODE,
            template: `project(${projectName})`,
        });

        const boardName = deviceDefinition.meta.zephyrName;
        const wokwiBoardName = deviceDefinition.meta.wokwiName;

        blocks.push({
            location: 'VSCODE_TASKS',
            blockType: BlockType.CODE,
            template: `
{
    "label": "West Build",
    "command": "source $ZEPHYR_BASE/../.venv/bin/activate && west build ./ -b ${boardName} --build-dir ./build",
    "windows": {
        "command": "west build ./ -b ${boardName} --build-dir ./build",
    },
    "type": "shell",
    "group": "build",
    "problemMatcher": []
},
{
    "label": "West Flash",
    "command": "source $ZEPHYR_BASE/../.venv/bin/activate && west flash --build-dir ./build",
    "type": "shell",
    "windows": {
        "command": "west flash --build-dir ./build",
    },
    "dependsOn": "West Build",
    "problemMatcher": []
},
{
    "label": "JLINK Flash",
    "command": "JLinkExe -device ${jlinkName} -if SWD -speed ${jlinkSpeed} -autoconnect 1 -CommanderScript jlink_flash.jlink",
    "type": "shell",
    "dependsOn": "West Build",
    "problemMatcher": []
},
{
    "label": "West Docker Build",
    "command": "docker run --rm -v $ZEPHYR_BASE/../:/workdir -v ./:/workdir/${projectName} ghcr.io/zephyrproject-rtos/zephyr-build:latest /bin/bash -c 'west build -b ${boardName} /workdir/${projectName} --build-dir /workdir/${projectName}/build'",
    "type": "shell",
    "problemMatcher": []
},
            `,
        });

        blocks.push({
            location: 'README',
            blockType: BlockType.CODE,
            template: `
set OPENOCD_PATH or OPENOCD_ESP_PATH
            `,
        });

        const device = PlatformUtils.getDeviceDefinition(this.project.device.id);
        // get openocd settings
        let debuggerPath = 'xtensa-espressif_esp32s3_zephyr-elf/bin/xtensa-espressif_esp32s3_zephyr-elf-gdb';
        let debuggerPathWindows = '';
        // get soc
        switch (device.soc) {
            case 'esp32':
                debuggerPath = 'xtensa-espressif_esp32_zephyr-elf/bin/xtensa-espressif_esp32_zephyr-elf-gdb';
                break;
            case 'esp32c3':
                debuggerPath = 'riscv64-zephyr-elf/bin/riscv64-zephyr-elf-gdb';
                break;
            case 'esp32s3':
                debuggerPath = 'xtensa-espressif_esp32s3_zephyr-elf/bin/xtensa-espressif_esp32s3_zephyr-elf-gdb';
                break;
            default:

                break;
        }

        if (debuggerPath !== '') {
            // replace with windows path
            debuggerPathWindows = debuggerPath.replace(/\//g, '\\\\');
            debuggerPathWindows += '.exe';
        }

        for (let i = 0; i < device.uploadMethods.length; i++) {
            const method = device.uploadMethods[i];
            if (method.name === 'openocd' && method.options.length > 0) {
                blocks.push({
                    location: 'OPENOCD_CFG_FILE',
                    blockType: BlockType.CODE,
                    template: method.options[0],
                });
            }
        }

        blocks.push({
            location: 'VSCODE_LAUNCH_COMMAND',
            blockType: BlockType.CODE,
            template: `
{
    "name": "GDB Launch",
    "type": "cppdbg",
    "request": "launch",
    "MIMode": "gdb",
    "debugServerArgs": "-f \${workspaceFolder}/openocd.cfg",
    "debugServerPath": "\${env:OPENOCD_PATH}/bin/openocd",
    "miDebuggerPath": "\${env:ZEPHYR_SDK_INSTALL_DIR}/${debuggerPath}",
    "miDebuggerServerAddress": "localhost:3333",
    "program": "\${workspaceFolder}/build/zephyr/zephyr.elf",
    "windows": {
        "debugServerArgs": "-f \${env:OPENOCD_PATH}\\\\share\\\\openocd\\\\scripts\\\\board\\\\esp32c3-builtin.cfg",
        "debugServerPath": "\${env:OPENOCD_PATH}\\\\bin\\\\openocd.exe",
        "miDebuggerPath": "\${env:ZEPHYR_SDK_INSTALL_DIR}\\\\${debuggerPathWindows}",
        "program": "\${workspaceFolder}\\\\build\\\\zephyr\\\\zephyr.elf",
    },
    "cwd": "\${workspaceFolder}",
    "serverStarted": "Listening on port 3333 for gdb connections",
    "useExtendedRemote": true,
    "stopAtEntry": true,
    "stopAtConnect": true,
    "preLaunchTask": "West Flash",
    "filterStderr": true,
    "filterStdout": false,
    "setupCommands": [
        {
            "text": "set remotetimeout 20"
        },
    ],
    "postRemoteConnectCommands": [
        {
            "text": "mon reset halt"
        },
        {
            "text": "maintenance flush register-cache"
        },
    ],
    "externalConsole": false,
    "logging": {
        "moduleLoad": false,
        "trace": true,
        "engineLogging": true,
        "programOutput": true,
        "exceptions": true
    },
    //"hardwareBreakpoints": {
    //    "require": true,
    //    "limit": 3
    //}
},
{
    "name": "Debug jLink",
    "request": "launch",
    "type": "cortex-debug",
    "servertype": "jlink",
    "cwd": "\${workspaceFolder}",
    "executable": "\${workspaceFolder}/build/zephyr/zephyr.elf",
    "armToolchainPath": "\${env:ZEPHYR_SDK_INSTALL_DIR}/arm-zephyr-eabi/bin",
    "interface": "swd",
    "toolchainPrefix": "arm-zephyr-eabi",
    "runToEntryPoint": "main",
    "showDevDebugOutput": "raw",
    "preLaunchTask": "West Flash",
    "device": "${jlinkName}"
},
{
    "type": "node-terminal",
    "name": "Upload Python files",
    "request": "launch",
    "preLaunchTask": "West Build",
    "command": "source $ZEPHYR_BASE/../.venv/bin/activate && west flash --build-dir ./build",
},
{
    "name": "Launch With JJLINK",
    "type": "cppdbg",
    "request": "launch",
    "cwd": "\${workspaceFolder}",
    "program": "\${workspaceFolder}/build/zephyr/zephyr.elf",
    "MIMode": "gdb",
    "miDebuggerPath": "\${env:ZEPHYR_SDK_INSTALL_DIR}/arm-zephyr-eabi/bin/arm-zephyr-eabi-gdb",
    "setupCommands": [
        {
            "text": "file '\${workspaceFolder}/build/zephyr/zephyr.elf"
        },
        {
            "text": "target remote localhost:3333"
        },
        
        {
            "text": "break main"
        },
    ],
    "targetArchitecture": "arm",
    "debugServerPath": "/Applications/SEGGER/JLink/JLinkGDBServerCLExe",
    "debugServerArgs": "-if swd -speed 4000 -endian little -port 3333 -device STM32F207VG",
    "serverStarted": "Connected to target",
    "filterStdout": true,
    //"stopAtConnect": true,
    "preLaunchTask": "JLINK Flash",
    // "svdPath": "\${workspaceFolder}/platforms/stm32f407vg/STM32F407.svd"
}
`,
        });

        blocks.push({
            location: 'VSCODE_SETTINGS',
            blockType: BlockType.CODE,
            template: `
// "python.defaultInterpreterPath": "\${env:ZEPHYR_BASE}\\\\..\\\\.venv\\\\Scripts\\\\python.exe"`,
        });

        blocks.push({
            location: 'WOKWI_TOML_FIRMWARE',
            blockType: BlockType.CODE,
            template: 'firmware = "./build/zephyr/zephyr.bin"',
        });

        blocks.push({
            location: 'WOKWI_TOML_ELF',
            blockType: BlockType.CODE,
            template: 'elf = "./build/zephyr/zephyr.elf"',
        });

        blocks.push({
            location: 'PRJ_CONF',
            blockType: BlockType.CODE,
            template: `
CONFIG_REBOOT=y

CONFIG_MAIN_STACK_SIZE=4096
CONFIG_HEAP_MEM_POOL_SIZE=4096
CONFIG_SYSTEM_WORKQUEUE_STACK_SIZE=4096
CONFIG_ZVFS_OPEN_MAX=16
CONFIG_ZVFS_EVENTFD_MAX=16

##### DEBUG
# CONFIG_EARLY_CONSOLE=y
# CONFIG_DEBUG=y
# CONFIG_DEBUG_INFO=y
# CONFIG_NO_OPTIMIZATIONS=y
# THREAD_ANALYZER=y
# THREAD_ANALYZER_AUTO=y
# THREAD_ANALYZER_USE_PRINTK=y
# CONFIG_NET_IPV4_LOG_LEVEL_DBG=y
# CONFIG_DEBUG_OPTIMIZATIONS=y
`,
        });

        blocks.push({
            location: 'WOKWI_PARTS',
            blockType: BlockType.CODE,
            template: `
{
    "type": "${wokwiBoardName}",
    "id": "esp",
    "top": 0,
    "left": 0
}`,
        });

        blocks.push({
            location: 'WOKWI_CONNECTIONS',
            blockType: BlockType.CODE,
            template: `
[ "esp:TX0", "$serialMonitor:RX", "", [] ],
[ "esp:RX0", "$serialMonitor:TX", "", [] ]`,
        });

        const LOGGING = this.getSettingValue('LOGGING');
        if (LOGGING !== '') {
            const outputFeature = this.project.getFeature(LOGGING);
            const outputPort = outputFeature.getSettingValue('PORT');
            blocks.push({
                location: 'APP_OVERLAY_CHOSEN',
                blockType: BlockType.CODE,
                template: `
zephyr,console=&${outputPort};`,
            });
        }

        blocks.push({
            location: 'GLOBAL_TYPES',
            blockType: BlockType.CODE,
            template: `
struct interface_set_params {
    int interface;
    bool state;
};

// Work item for interface_set
static struct k_work interface_set_work;
static struct interface_set_params interface_params;`,
        });

        blocks.push({
            location: 'FUNCTION_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
void interface_set(int interface, bool state);`,
        });

        blocks.push({
            location: 'FUNCTION_DEFINITIONS',
            blockType: BlockType.CODE,
            template: `
void interface_set(int interface, bool state)
{
    /****interface_set****/
}

static void interface_set_work_handler(struct k_work *work)
{
    interface_set(interface_params.interface, interface_params.state);
}
`,
        });

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
k_work_init(&interface_set_work, interface_set_work_handler);`,
        });

        return blocks;
    }
}
